import { useCallback, useState } from 'react';
import devLogger from 'react-utils/devLogger';
export function useChildDOMNode() {
  const [element, setElement] = useState(null);
  const refCallback = useCallback(instance => {
    if (instance == null) {
      setElement(null);
    } else if (instance instanceof Element) {
      setElement(instance);
    } else if (process.env.NODE_ENV !== 'production') {
      devLogger.warn({
        message: 'A class component was passed as a child without using React.forwardRef. ' + 'Use the `target` prop or wrap your component in forwardRef.',
        key: 'useChildDOMNode:class-instance-fallback'
      });
    }
  }, []);
  return [refCallback, element];
}